module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido16.20afe852.svg";